var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgTableau = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 48H33C33.7956 48 34.5587 48.3161 35.1213 48.8787C35.6839 49.4413 36 50.2044 36 51V91.5H24V51C24 50.2044 24.3161 49.4413 24.8787 48.8787C25.4413 48.3161 26.2044 48 27 48Z",
    fill: "#FF8989"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 61.5H49.5C50.2956 61.5 51.0587 61.8161 51.6213 62.3787C52.1839 62.9413 52.5 63.7044 52.5 64.5V91.5H40.5V64.5C40.5 63.7044 40.8161 62.9413 41.3787 62.3787C41.9413 61.8161 42.7044 61.5 43.5 61.5Z",
    fill: "#D14547"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60 49.5H66C66.7956 49.5 67.5587 49.8161 68.1213 50.3787C68.6839 50.9413 69 51.7044 69 52.5V91.5H57V52.5C57 51.7044 57.3161 50.9413 57.8787 50.3787C58.4413 49.8161 59.2044 49.5 60 49.5Z",
    fill: "#FF8080"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5 91.5H73.5V33C73.5 32.2044 73.8161 31.4413 74.3787 30.8787C74.9413 30.3161 75.7044 30 76.5 30H82.5C83.2956 30 84.0587 30.3161 84.6213 30.8787C85.1839 31.4413 85.5 32.2044 85.5 33V91.5Z",
    fill: "#FFA0A0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5 4.5V10.5H78L49.5 39L31.5 21L7.5 45L12 49.5L31.5 30L49.5 48L82.5 15V19.5H88.5V4.5H73.5Z",
    fill: "#FFA0A0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30 81C30.0009 82.8434 29.5161 84.6545 28.5945 86.2509C27.6728 87.8474 26.3468 89.1728 24.75 90.0937L24.7406 90.1013C23.3452 90.9047 21.7838 91.3764 20.177 91.4801C18.5701 91.5837 16.961 91.3165 15.474 90.699C13.9869 90.0816 12.6618 89.1304 11.601 87.9191C10.5402 86.7078 9.77221 85.2687 9.35632 83.7132C8.94044 82.1577 8.88783 80.5274 9.20257 78.9483C9.51731 77.3692 10.191 75.8837 11.1714 74.6065C12.1519 73.3293 13.413 72.2947 14.8571 71.5826C16.3013 70.8706 17.8898 70.5001 19.5 70.5V81H30Z",
    fill: "#FFA0A0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24 66C26.7848 66 29.4555 67.1062 31.4246 69.0754C33.3938 71.0445 34.5 73.7152 34.5 76.5L24 76.5V66Z",
    fill: "#FFB0B0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 90.0938L24.7406 90.1013C23.1439 91.0197 21.3337 91.5021 19.4917 91.5C17.6497 91.4979 15.8406 91.0115 14.246 90.0894C12.6513 89.1674 11.3272 87.8422 10.4064 86.2469C9.48565 84.6515 9.00062 82.842 9 81H19.5L24.75 90.0938Z",
    fill: "#FF8080"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30 81C30.0009 82.8434 29.5162 84.6545 28.5945 86.2509C27.6729 87.8474 26.3468 89.1728 24.75 90.0938L19.5 81H30Z",
    fill: "#FFB0B0"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTableau, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tableau.446de8ac.svg";
export { ForwardRef as ReactComponent };